// reducers/form.reducer.ts
import { createReducer, on } from '@ngrx/store';
import {
  resetForm,
  submitForm,
  submitFormFailure,
  submitFormSuccess,
} from '../actions/form.actions';

export interface FormState {
  [entity: string]: {
    saving: boolean;
    success: boolean;
    error: any;
    object: any;
    isCreated: boolean;
    list: any[];
  };
}

export const initialState: FormState = {};

const _formReducer = createReducer(
  initialState,
  on(submitForm, (state, { entity }) => ({
    ...state,
    [entity]: { ...state[entity], saving: true, success: false, error: null },
  })),
  on(submitFormSuccess, (state, { entity, object, isCreated }) => ({
    ...state,
    [entity]: {
      ...state[entity],
      saving: false,
      success: true,
      object: object,
      isCreated: isCreated,
    },
  })),
  on(submitFormFailure, (state, { entity, error }) => ({
    ...state,
    [entity]: { ...state[entity], saving: false, success: false, error },
  })),
  on(resetForm, (state, { entity }) => ({
    ...state,
    [entity]: { ...state[entity], saving: false, success: false, error: null },
  })),
);

export function formReducer(state: any, action: any) {
  return _formReducer(state, action);
}
